import styles from '../styles/Skills.module.css';

const ICONS = {
  cms: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="4" width="18" height="16" rx="1" />
      <path d="M3 9h18" />
      <circle cx="6.5" cy="6.5" r="0.75" fill="currentColor" stroke="none" />
      <circle cx="9" cy="6.5" r="0.75" fill="currentColor" stroke="none" />
    </svg>
  ),
  code: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8.5 8 4 12l4.5 4" />
      <path d="M15.5 8 20 12l-4.5 4" />
      <path d="M13.5 6 10.5 18" />
    </svg>
  ),
  server: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3.5" y="4" width="17" height="6.5" rx="1" />
      <rect x="3.5" y="13.5" width="17" height="6.5" rx="1" />
      <circle cx="7" cy="7.25" r="0.75" fill="currentColor" stroke="none" />
      <circle cx="7" cy="16.75" r="0.75" fill="currentColor" stroke="none" />
    </svg>
  ),
  cloud: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M7 18h10a4 4 0 0 0 .5-7.97 5.5 5.5 0 0 0-10.6 1.5A3.5 3.5 0 0 0 7 18Z" />
    </svg>
  ),
};

const CATEGORIES = [
  {
    title: 'WordPress & CMS',
    accent: 'cy',
    icon: 'cms',
    skills: [
      'Custom Theme Development',
      'Custom Plugin Development',
      'CPTs, ACF, Shortcodes',
      'Hooks & Filters',
      'WooCommerce',
      'Tutor LMS',
      'Elementor, Divi',
      'Contact Form 7',
      'Yoast SEO, RankMath',
      'WP-CLI',
    ],
  },
  {
    title: 'Frontend',
    accent: 'pu',
    icon: 'code',
    skills: [
      'HTML5, CSS3, JavaScript (ES6+)',
      'React.js',
      'Bootstrap',
      'GSAP, Three.js',
      'Responsive Design',
    ],
  },
  {
    title: 'Backend & Database',
    accent: 'cy',
    icon: 'server',
    skills: [
      'PHP (Core + WordPress)',
      'Node.js, Express.js',
      'MongoDB, MySQL',
      'REST APIs',
      'JWT Authentication',
      'Socket.io',
    ],
  },
  {
    title: 'DevOps, Hosting & SEO',
    accent: 'pu',
    icon: 'cloud',
    skills: [
      'Shared Hosting & VPS Server Management',
      'DNS & Email: Cloudflare, SPF, DKIM, DMARC, SMTP',
      'Technical SEO (Screaming Frog, Core Web Vitals)',
      'Google PageSpeed (90+), Schema.org Markup',
    ],
  },
];

export default function Skills() {
  return (
    <section id="skills" className="section">
      <div className="container">
        <div className="section-head" data-anim>
          <span className="section-index">02</span>
          <span className="section-rule" />
          <h2 className="section-title">Skills</h2>
        </div>

        <div className={styles.grid}>
          {CATEGORIES.map((cat) => (
            <div key={cat.title} className={`${styles.card} ${styles[cat.accent]}`} data-skill>
              <div className={styles.head}>
                <div className={styles.headLeft}>
                  <span className={`${styles.iconWrap} ${styles[cat.accent]}`}>{ICONS[cat.icon]}</span>
                  <span className={styles.title}>{cat.title}</span>
                </div>
                <span className={styles.count}>{String(cat.skills.length).padStart(2, '0')}</span>
              </div>
              <div className={styles.tags}>
                {cat.skills.map((skill) => (
                  <span key={skill} className={styles.tag}>
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
